
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Space Opera by Georgi Gospodinov | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `In Space Opera, Georgi Gospodinov takes readers on a cosmic journey through the lives of astronauts and the vastness of space, exploring themes of existence, identity, and the human experience.`);


  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Three/GeorgiGospodinov_09_Mockup1.webp', '../../Series-Three/GeorgiGospodinov_09_Mockup2.webp', '../../Series-Three/GeorgiGospodinov_09_Mockup3.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Space Opera</h1>
            <div className='productAuthor'>Georgi Gospodinov</div>
            <div className='productTranslator'>Translated by Angela Rodel</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416574'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>


          <div className='productDescription'>The frontiers of the sublime extend into the far reaches of space in Georgi Gospodinov’s cosmic adventure starring archetypal astronauts Adam and Eve, Laika the dog and naturally, a <em>Musca domestica</em> or fruit fly. The Bulgarian author’s exercise in libretto writing takes the shape of a “giant poem” patterned after a hyper-saturated present where “information is everything/And everything is information…isn’t it?”. In answer, Gospodinov heads out of bounds, roving between Mars and Earth; voices, scales, valences of emotion. Mediated by camera cues and an insectoid chorus, <em>Space Opera</em> is a genre-collapsing work engaging an irreducible expanse of human and more-than-human experience on the cusp of seismic evolution.
          </div>
          <div className='productDescription'>
            <p>
              <strong>Georgi Gospodinov</strong> transduces the psychic landscape of central and Eastern Europe through a literature of temporal diffusion and mythic sojourn. Gospodinov’s work encompasses poetry, installations and novels addressing modern philosophical tensions, such as <em>Time Shelter</em>, which received the 2023 International Booker Prize. He is an associate professor at the Institute of Literature in Sofia, Bulgaria.

            </p>
            <p>
              Co-winner of the 2023 International Booker Prize for her translation of Georgi Gospodinov’s <em>Time Shelter</em>, <strong>Angela Rodel</strong> is a literary translator, actor, and musician who lives and works in Bulgaria. Originally from Minnesota, Rodel holds degrees from Yale and UCLA, and has received NEA and PEN translation grants.
            </p>
            <p><em>Back cover photo: Tihomira Krumova</em></p>
          </div>
          <div className='productMetadata'>
            <div>Series III, No. 9</div>
            <div>Summer 2025</div>
            <div>ISBN 979–8–990416–57–4</div>
            <div>4.125 x 2.75 inches</div>
            <div>176 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)
}